import PropTypes from 'prop-types';
import { H2 } from 'foundations-components/transitional/components/H2';
import { HR } from 'foundations-components/transitional/components/HR';
import { Section } from 'foundations-components/transitional/components/Section';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The header lets the user know what settings page they are on with a title and small description at the top of the page.
 *
 * - This component is **required** for all settings pages.
 * - This component will show the current page title, which should directly match the sidebar label.
 * - This component includes a required description about what these settings will impact (i.e. These settings will apply across the entire account.)
 */
export const Header = ({
  title,
  description,
  navigation,
  secondaryNavigation
}) => {
  const bottomChunk = secondaryNavigation || /*#__PURE__*/_jsx(HR, {
    marginBlockStart: "400"
  });
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "settings-ui-lib-header",
    marginBlockEnd: "700",
    children: [/*#__PURE__*/_jsx(H2, {
      children: title
    }), navigation && /*#__PURE__*/_jsx(Section, {
      children: navigation
    }), description && /*#__PURE__*/_jsx(View, {
      maxInlineSize: "900px",
      marginBlockEnd: "400",
      children: description
    }), bottomChunk]
  });
};
Header.propTypes = {
  /**
   * Primary title for the page.
   */
  title: PropTypes.node.isRequired,
  /**
   * Required description for what settings will impact.
   */
  description: PropTypes.node,
  /**
   * Primary local navigation node.
   */
  navigation: PropTypes.node,
  /**
   * Secondary local navigation node.
   */
  secondaryNavigation: PropTypes.node
};
export default Header;